export class StudentSearchSubmitNewStudentRequest {
    lastName: string;
    middleName: string;
    firstName: string;
    gender: number | string | { value: number };
    dob: Date;
    homeBorough: number | { value: number };
    streetName: string;
    houseNumber: string;
    city: string;
    state: number | { value: number };
    zip: string;
    guardianRelationship: number | { value: number };
    guardianFirstName: string;
    guardianLastName: string;
    schoolDistrict: number | { value: number };
    apartmentNumber: string;
    studentSk: string;
    guardianId: string;
    reasonforReferral: number[];
    bypassDuplicateCheck: boolean;
    addedBy: string;
    constructor(newStudent: StudentSearchSubmitNewStudentRequest) {
        this.lastName = newStudent?.lastName;
        this.middleName = newStudent?.middleName;
        this.firstName = newStudent?.firstName;
        this.gender = (newStudent?.gender as { value: number })?.value;
        this.dob = newStudent?.dob;
        this.homeBorough = (newStudent?.homeBorough as { value: number })?.value;
        this.streetName = newStudent?.streetName;
        this.houseNumber = newStudent?.houseNumber;
        this.city = newStudent?.city;
        this.state = (newStudent?.state as { value: number })?.value;
        this.zip = newStudent?.zip;
        this.guardianRelationship = (newStudent?.guardianRelationship as { value: number })?.value;
        this.guardianFirstName = newStudent?.guardianFirstName;
        this.guardianLastName = newStudent?.guardianLastName;
        this.schoolDistrict = (newStudent?.schoolDistrict as { value: number })?.value;
        this.apartmentNumber = newStudent?.apartmentNumber;
        this.studentSk = newStudent?.studentSk;
        this.guardianId = newStudent?.guardianId;
        this.reasonforReferral = newStudent?.reasonforReferral;
    }

    readonly id: string = '';
}